import request from '@/utils/request'

// 登录 return promise 实例
export const login = (data) => {
    return request({
        url: '/public/login',
        method: 'POST',
        data
    })
}

// 获取用户信息
export const getUserInfo = () => {
    return request({
        url: '/user/profile'
    })
}

// 修改用户信息
export const updateUserInfo = (data) => {
    return request({
        url: '/user/profile',
        method: 'PATCH',
        data
    })
}

// 修改密码
export const updatePassword = (data) => {
    return request({
        url: '/user/update_password',
        method: 'POST',
        data
    })
}

// 演示账号自动登录
export const aotuLogin = () => {
    return request({
        url: '/demo/login',
        method: 'POST',
        data: {
            username: 'demo',
            password: 'time@666'
        }
    })
}

// 获取公钥
export const getRsa = () => {
    return request({
        url: '/public/info'
    })
}

/**
 * 导入
 *  * @param {*} module 导入模块类型
 */
export const importsRoom = (module, data, params = {}) => {
    let params_str = ''
    if (JSON.stringify(params) !== '{}') {
        params_str =
            '?' +
            Object.keys(params)
                .map((key) => key + '=' + params[key])
                .join('&')
    }
    return request({
        url: `/${module}/excel/imports${params_str}`,
        method: 'POST',
        data
    })
}

/**
 * 下载导入模板
 */
export const downloadTemplate = (module, data) => {
    return request({
        url: `/${module}/excel/imports`,
        method: 'GET',
        params: data
    })
}

// 获取学校类型
export const getSchoolType = () => {
    return request({
        url: '/heating/school/type'
    })
}
